import React from "react";
import { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { verifySms } from "../../../features/user/userSlice";

export default function CodeNumberModal({ onCodeChange }) {
  const [code, setCode] = useState(["", "", "", ""]);
  const inputsRef = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);
    if (value && index < 3) {
      inputsRef.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  useEffect(() => {
    onCodeChange(code.join(""));
  }, [code]);

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
        <h2 className="kn-h3 mb-4">Code eingeben</h2>

        <div className="flex gap-3 justify-center mt-4 mb-6">
          {code.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputsRef.current[index] = el)}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="w-12 h-12 text-center text-xl text-knapp-ink border border-knapp-borderInput rounded-xl"
            />
          ))}
        </div>

        <div className="flex justify-between gap-4">
          <button className="flex-1 kn-btn-primary">Code bestätigen</button>

          <button className="flex-1 kn-btn-ghost">Code erneut senden</button>
        </div>
      </div>
    </div>
  );
}
